import { render, staticRenderFns } from "./dptIndex.vue?vue&type=template&id=8f94750c&"
import script from "./dptIndex.vue?vue&type=script&lang=js&"
export * from "./dptIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports